<span class="switch" (click)="handleChange(!checked())">
  <input class="input-element" type="checkbox" [checked]="checked()">
  <span class="slider"></span>
</span>
